(() => {
    const storageKey = 'cmenya_recent';
    let checkedProductsData = JSON.parse(localStorage.getItem(`[${storageKey}]`) || '[]');
    const elts = document.querySelectorAll('.js-cm-checked');

    /*********/

    class Product {
        constructor(handle) {
            this.handle = handle;

            this.data = {
                id: null,
                title: null,
                price: null,
                priceVaries: false,
                priceMin: null,
                priceMax: null,
                compareAtPrice: null,
                img: null,
                available: false,
                sale: false,
                preorder: false,
                preorderBto: false
            }
        }

        static formatPrice(price) {
            return new Intl.NumberFormat('ja-JP').format((price / 100.0).toFixed());
        }

        init() {
            return this.getProductData().then((data) => {
                if (!data || !data.handle) {
                    return null
                } else {
                    this.setProductData(data);
                    return this;
                }
            });
        }

        setProductData(data) {
            this.data.id = data.id;
            this.data.title = data.title;
            this.data.price = Product.formatPrice(data.price);
            this.data.priceVaries = data.price_varies;
            this.data.priceMin = Product.formatPrice(data.price_min);
            this.data.priceMax = Product.formatPrice(data.price_max);
            this.data.compareAtPrice = data.compare_at_price ? Product.formatPrice(data.compare_at_price) : null;
            this.data.img = data.images[0] ? data.images[0] : data.featured_image;
            this.data.available = data.available;
            this.data.sale = data.compare_at_price ? data.compare_at_price > data.price : false;
            this.data.preorder = data.tags.includes('予約');
            this.data.preorderBto = data.tags.includes('受注生産') || data.tags.includes('完全受注生産');
        }

        getProductData() {
            return fetch(`${window.Shopify.routes.root}products/${this.handle}.js`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`);
                }

                return response.json();

                }).catch((error) => {});
        }
    }

    class ProductSlider {
        constructor(container) {
            this.variesSymbol = window.Shopify.locale === 'ja' ? '～' : ' - ';
            this.removePrice = window.Shopify.currency.active !== 'JPY';
            /////
            this.sliderInit = false;
            this.displayLimit = Number(container.dataset.checkedLimit) || 10;
            this.currentPage = container.dataset.checkedPage;
            this.currentProduct = this.currentPage === 'product' ? (container.dataset.checkedProduct || null) : null;
            /////
            this.container = container;
            this.slider = container.querySelector('.js-cm-checked-slider');
            this.sliderList = this.slider ? this.slider.querySelector('.splide__list') : null;
            this.slideTemplate = this.slider ? this.slider.querySelector('.js-cm-slide-template') : null;
        }

        init() {
            if (!this.slider) return;

            if (!(this.sliderList && this.slideTemplate)) return;

            if (this.currentProduct) {
                addProduct(this.currentProduct);
                updateStorage();
            }

            if (checkedProductsData.length >= 1) {
                // TODO: outside of loop (1 time per page)
                getProducts().then((list) => {
                    updateProducts(list, this.displayLimit);
                    updateStorage();
                    this.renderSlider(list.filter((productItem) => productItem && productItem.handle != this.currentProduct));
                });
            } else {
                const hamburgerList = document.querySelector('.menu-drawer__checked');
                const section = document.querySelector('.cm-checked-container');
                
                if (section) {
                    section.style.display = 'none';
                }
                
                if (hamburgerList) {
                    hamburgerList.style.display = 'none';
                }
            }
        }

        renderSlider(products) {
            products.forEach((productItem, i) => {
                const slideClone = this.slideTemplate.content.cloneNode(true).firstElementChild;
                this.renderPrice(slideClone, productItem.data);
                this.renderInfo(slideClone, productItem.handle, productItem.data.title, productItem.data.id);
                this.renderImage(slideClone, productItem.data.img);
                // レビューア↓↓↓
                this.renderRating(slideClone, productItem.handle);
                // レビューア↑↑↑

                this.sliderList.append(slideClone);
            });
    
            window.addEventListener('DOMContentLoaded', () => {
                this.initSlider(this.slider);
            });
            if (this.sliderInit) return;
            window.setTimeout(() => {
                this.initSlider(this.slider);
            }, 2000);
        }

        renderPrice(slide, data) {
            const priceContainer = slide.querySelector('.card-information > .price');
    
            if (this.removePrice) {
                priceContainer.remove();
                return;
            }

            if (data.available) {
                priceContainer.classList.remove('price--sold-out');
            }
    
            if (data.priceVaries){
                priceContainer.querySelector('.price__regular .price-item__amount').innerHTML = `<span class="price-item__amount">${data.priceMin}</span><span class="price-item-yen">円</span><span class="price-item-from">${this.variesSymbol}</span><span class="price-item__amount">${data.priceMax}</span><span class="price-item-yen">円</span>`;
    
                if (data.available) {
                    priceContainer.classList.add('price--varies-sale');
                }
            }
            else if (data.sale) {
                priceContainer.classList.add('price--on-sale');
                priceContainer.querySelector('.price__sale .price-item--regular').innerHTML = `<span class="price-item__amount">${data.compareAtPrice}</span><span class="price-item-yen">円</span>`;
                priceContainer.querySelector('.price__sale .price-item--sale .price-item__amount').innerHTML = `<span class="price-item__amount">${data.price}</span><span class="price-item-yen">円</span>`;
            }
            else {
                priceContainer.querySelector('.price__regular .price-item__amount').innerHTML = `<span class="price-item__amount">${data.price}</span><span class="price-item-yen">円</span>`;
            }
        }

        renderInfo(slide, handle, title, id) {
            const link = slide.querySelector('.card__heading a');
            //const setId = {% if section.settings.link_id_prefix != blank %}'{{ section.settings.link_id_prefix }}'{% else %}null{% endif %}
            const setId = null;
            link.href = `${window.Shopify.routes.root}products/${handle}`
            link.removeAttribute('aria-disabled');
            link.textContent = title;
    
            if (setId) {
                link.id = `${setId}-${id}`;
            }
        }

        renderImage(slide, image) {
            const placeholder = slide.querySelector('.placeholder-svg');
        
            if (!placeholder) return;
    
            if (!image) {
                placeholder.remove();
                return;
            }
    
            const img = document.createElement('img');
            img.src = image;
            img.width = '350';
            img.height = '350';
            img.loading = 'lazy';
            img.alt = '';
    
            slide.querySelector('.card').classList.add('card--media');
    
            placeholder.replaceWith(img);
        }

        renderRating(slide, handle) {
            try {
                fetch(`${window.Shopify.routes.root}products/${handle}?view=rating`, {
                    method: "GET",
                }).then((response) => {
                    return response.text();
                }).then((data) => {
                    const ratingValue = data.trim();

                    if (Number(ratingValue) > 0) {
                        this.addRating(Math.floor(ratingValue), slide);
                    }
                })
            } catch (error) {
                console.error(error);
            }
        }

        addRating(ratingValue, slide) {
            const ratingContainer = document.createElement('div');
            ratingContainer.classList.add('rating');
            const container = slide.querySelector('.card-information');
            // TODO get metafields.reviews.rating.value.scale_max
            const max = 5.0;
            const decimal = 0;

            if (!container) return;

            
            ratingContainer.innerHTML = `
                <span
                  aria-hidden="true"
                  class="rating-star"
                  style="--rating: ${ratingValue}; --rating-max: ${max}; --rating-decimal: ${decimal};"
                ></span>
            `;

            container.prepend(ratingContainer);
        }

        initSlider() {
            if (!Splide || this.sliderInit) return;
            this.sliderInit = true;
    
            const splide = new Splide(this.slider, {
                fixedWidth: '150px',
                pagination: false,
                arrows: false,
                // i18n: {
                //     prev: text.prev,
                //     next: text.next,
                //     slideX: text.slideX
                // },
                gap: '30px',
                padding: 'max(100px, calc((100vw - 1400px) / 2))',
                breakpoints: {
                    750: {
                        gap: '10px',
                        padding: '5vw',
                    }
                }
            });
    
            splide.mount();
        }
    }

    /*********/

    async function getProducts() {
        const productList = await checkedProductsData.map(async (handle, i) => {
            const productItem = await new Product(handle).init();
            return productItem;
        });

        return Promise.all(productList);
    }

    function addProduct(currentProduct) {
        // ローカルストレージに同じ商品が存在する場合、削除
        const duplicateIndex = checkedProductsData.findIndex((handle) => handle === currentProduct );
        if (duplicateIndex > -1) {
            checkedProductsData.splice(duplicateIndex, 1);
        }

        // 現在表示されている商品情報を追加
        checkedProductsData.unshift(currentProduct);
    }

    function updateProducts(list, displayLimit) {
        // 商品が正しく登録されてないと削除
        let newList = list.filter((product, i) => product && product.handle);

        // 指定した個数を超えた場合、削除
        if (newList.length > displayLimit) {
            newList = newList.slice(0, displayLimit);
        }
        
        checkedProductsData = newList.map((product) => product.handle);
    }

    function updateStorage() {	
        // ローカルストレージに格納
        try {
            localStorage.setItem(`[${storageKey}]`, JSON.stringify(checkedProductsData));
        } catch (error) {}
    }

    /*********/    

    if (elts.length < 1) return;

    elts.forEach(container => {
        const slider = new ProductSlider(container);
        slider.init();
    });
})();